import { render, staticRenderFns } from "./setting_package.vue?vue&type=template&id=043c2e8d"
import script from "./setting_package.vue?vue&type=script&lang=js"
export * from "./setting_package.vue?vue&type=script&lang=js"
import style0 from "./setting_package.vue?vue&type=style&index=0&id=043c2e8d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports